import { autoinject, transient } from "aurelia-framework";
import { NotifyPropertyChangedBase } from "../../../../../../utilities/reflection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { OnboardingAdminService } from "../../../../../../services/onboarding/onboarding-admin.service";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { I18N } from "aurelia-i18n";
import { BaseClaims } from "../../../../../../constants/authentication/base-claims";
import { CloneOnboardingRequest } from "../../../../../../models/onboarding/onboarding.models";

@autoinject
@transient()
export class CloneOnboardingdialog extends NotifyPropertyChangedBase {
    private _itemId: number;
    private _actionAfterClone: () => void;

    public name: string;
    public internalName: string;
    public useDifferentName: boolean;
    protected canChangeInternalName: boolean;

    constructor(private dialogClient: DialogClientService, private onboardingAdminService: OnboardingAdminService,
        private notificationService: NotificationClientService, private i18N: I18N, private userClaims: UserClaimsService) {
        super();
        this.canChangeInternalName = this.userClaims.hasPermission(BaseClaims.ChangeCloneInternalName);
    }

    clone() {
        return new Promise<void>((resolve, reject) => {
            if (this.areThereEmptyFields()) {
                this.notificationService.show(this.i18N.tr("empty-fields"), this.i18N.tr("empty-fields-description"), NotificationType.Error);
                reject();
            }
            else {
                const request: CloneOnboardingRequest = {
                    onboardingId: this._itemId,
                    onboardingName: this.name,
                    internalName: (this.useDifferentName && this.canChangeInternalName) ? this.internalName : null
                }

                this.onboardingAdminService.cloneOnboardingConfig(request)
                    .then(x => {
                        if (x.isSuccess) {
                            this.notificationService.show(this.i18N.tr("successful-cloning-text").replace('{0}', this.name), this.i18N.tr("onboarding-clone-success-text"), NotificationType.Success, 5000);
                        }

                        resolve();
                        this.dialogClient.hide();

                        if (this._actionAfterClone instanceof Function) {
                            this._actionAfterClone();
                        }
                    })
                    .catch(() => {
                        this.notificationService.show(this.i18N.tr("failed-cloning-text"), this.i18N.tr("onboarding-clone-failure-text"), NotificationType.Error, 5000);
                        reject();
                    });
            }
        });
    }

    areThereEmptyFields() {
        if (!this.name || (this.useDifferentName && !this.internalName)) {
            return true;
        }
        else {
            return false;
        }
    }

    cancel() {
        this.dialogClient.hide();
    }

    activate(model: any) {
        this._itemId = model.itemId;
        this._actionAfterClone = model.actionAfterClone;
    }
}
